/**
 * Fusionne deux listes d'events en ajoutant a `primaryEvents` les elements de
 * `extraEvents` dont l'id n'est pas deja present, sans dupliquer.
 *
 * Utilise pour combiner le flux de decouverte active (`events`, filtre
 * temporel SQL) avec l'historique personnel (`historyEvents`, toutes dates)
 * avant de calculer la carte de participation ou de resoudre une notification
 * par id — sinon une sortie passee organisee/rejointe (presente uniquement
 * dans `historyEvents`) ne serait jamais retrouvee (cf.
 * docs/map-performance-mobile-scroll-audit.md, C21/C22).
 */
export function mergeUniqueEventsById(primaryEvents = [], extraEvents = []) {
  const safePrimary = Array.isArray(primaryEvents) ? primaryEvents : [];
  const safeExtra = Array.isArray(extraEvents) ? extraEvents : [];

  if (!safeExtra.length) {
    return safePrimary;
  }

  const seenIds = new Set(
    safePrimary.map((eventItem) => eventItem?.id).filter(Boolean)
  );
  const newEvents = safeExtra.filter(
    (eventItem) => eventItem?.id && !seenIds.has(eventItem.id)
  );

  return newEvents.length ? [...safePrimary, ...newEvents] : safePrimary;
}
